import store from "../redux/store";
import { updateCommonInfo } from "../redux/commonSlice";
import * as _ from "../constants/Constants";

const END_POINTS = {
  getVendorStatusDetails: "/vendorProfile/getVendorStatusByprofileId",
};

export const getVendorStatusDetailsInterceptor = (response) => {
  if (response.config?.url?.startsWith(END_POINTS.getVendorStatusDetails)) {
    extractVendorMenuByStatus(response.data);
  }
};

const extractVendorMenuByStatus = (statuses = []) => {
  let vendorMenuItems = [];
  if (statuses && statuses.length > 0) {
    statuses.forEach((item) => {
      if (item.statusName) vendorMenuItems.push(item.statusName);
    });
  }
  store.dispatch(updateCommonInfo({ vendorMenuItems }));
};
